<script setup lang="ts">
// COMPOSABLES
const { tt } = useTypedI18n();

// DATA
const year = new Date().getFullYear();
</script>

<template>
    <span>© {{ year }} Fleequid - {{ tt('footer.vat') }} 04114790134 - {{ tt('copyright.allRightsReserved') }}</span>
</template>
